import React from 'react';
import { useTranslation } from 'react-i18next';
import { Callout } from '@blueprintjs/core';
import FormButtons from 'components/FormButtons';
import { FormLayout, FormLayoutContent } from 'components/FormLayout';
import FormPanel from 'components/FormPanel';
import './collection-function-form-missing-templates.scss';

type Props = {
  title: string
  onClickCancelClose: () => void
}

const CollectionFunctionFormMissingTemplates = ({
  title,
  onClickCancelClose,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className="collection-function-form collection-function-form-missing-template" data-testid="CollectionFunctionFormMissingTemplates">
      <FormLayout>
        <FormLayoutContent>
          <FormPanel title={title}>
            <FormButtons
              isEditing
              onClickCancel={onClickCancelClose}
              onClickClose={onClickCancelClose}
            />
          </FormPanel>
          <div className="callout">
            <Callout
              title={t('collectionFunction.missingTemplate.title')}
              icon="error"
              intent="danger"
            >
              {t('collectionFunction.missingTemplate.message')}
            </Callout>
          </div>
        </FormLayoutContent>
      </FormLayout>
    </div>
  );
};

export default CollectionFunctionFormMissingTemplates;
